import Icon from '../components/Icon.vue'

Icon.register({
  trademark: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M260.6 96c6.6 0 12 5.4 11.9 12v43.1c0 6.6-5.4 12-12 12h-85.1v240.9c0 6.6-5.4 12-12 12h-54.3c-6.6 0-12-5.4-12-12v-240.9h-85.1c-6.6 0-12-5.4-12-12v-43.1c0-6.6 5.4-12 12-12h248.6zM640 403c0.5 7-5 13-12 13h-53.9c-6.3 0-11.6-4.9-12-11.2l-9.1-132.9c-1.8-24.2 0-53.7 0-53.7h-0.9s-10.7 33.6-17.9 53.7l-30.7 84.7c-1.7 4.7-6.2 7.9-11.3 7.9h-50.3c-5.1 0-9.6-3.2-11.3-7.9l-30.7-84.7c-7.2-20.1-17.9-53.7-17.9-53.7h-0.9s1.8 29.5 0 53.7l-9.1 132.9c-0.5 6.3-5.7 11.2-12 11.2h-54.5c-7.1 0-12.6-6-12-13l24.4-296c0.6-6.2 5.8-11 12-11h65.4c5.1 0 9.6 3.3 11.3 8.1l43.8 127.1c7.2 20.6 16.1 52.8 16.1 52.8h0.9s8.9-32.2 16.1-52.8l43.8-127.1c1.6-4.8 6.2-8.1 11.3-8.1h65.4c6.3 0 11.5 4.8 12 11z'
      }
    ]
  }
})
